import { render, staticRenderFns } from "./ReviewSaveCancelIcons.vue?vue&type=template&id=5974f65b&scoped=true"
import script from "./ReviewSaveCancelIcons.vue?vue&type=script&lang=ts"
export * from "./ReviewSaveCancelIcons.vue?vue&type=script&lang=ts"
import style0 from "./ReviewSaveCancelIcons.vue?vue&type=style&index=0&id=5974f65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974f65b",
  null
  
)

export default component.exports